import Vue from 'vue'
import Router from 'vue-router'
import index from '../components/index/index'
// import moreinfo from '../components/moreinfo/moreinfo'
// import infolist from '../components/moreinfo/infolist'
// import qiuZhi from '../components/moreinfo/qiuZhi'
// import signinfo from '../components/moreinfo/signinfo'
// import infodetail from '../components/infodetail/infodetail'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',name: 'index',component: index
    },
 //    {
 //      path: '/infodetail',name: 'infodetail',component: infodetail
 //    },
	// {
	//   path: 'qiuZhi',name: 'qiuZhi',component: qiuZhi
	// },
 //    {
 //      path: '/:codenum',name: 'moreinfo',component: moreinfo,//动态路由
 //      children:[//嵌套路由
 //        {
 //          path: 'infolist',name: 'infolist',component: infolist
 //        },
       
 //        {
 //          path: 'signinfo',name: 'signinfo',component: signinfo
 //        }
 //      ]
      
 //    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js